module.exports = __webpack_public_path__ + "img/contactBackgroundTop.1aea3799.svg";